// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609071704/js/" + chunkId + "." + {"44":"6441c6b9","225":"80eccf46","481":"2e4cdafe","486":"3ba0dbe8","770":"20f63763"}[chunkId] + ".0.5547817429758548.chunk.js";
};